import { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { usePageTitle } from "../contexts/PageTitleContext";

const WeddingReprint = () => {
  const { setPageTitle } = usePageTitle();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const isDesktop = window.matchMedia("(min-width: 881px)").matches;
    setSidebarOpen(isDesktop);
    const handleResize = () =>
      setSidebarOpen(window.matchMedia("(min-width: 881px)").matches);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setPageTitle(
      "Marriage — Reprint",
      "Reprint previously issued marriage certificates",
    );
  }, [setPageTitle]);

  return (
    <div
      className={`dashboard-body ${sidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
    >
      <Topbar
        onMenuToggle={() => setSidebarOpen((p) => !p)}
        sidebarOpen={sidebarOpen}
      />
      <Sidebar isOpen={sidebarOpen} />
      <main className="main-content">
        <section className="dashboard-hero">
          <div className="dashboard-hero-text">
            <h1>Marriage — Reprint</h1>
            <p>Reprint previously issued marriage certificates.</p>
          </div>
        </section>
        <div
          style={{
            padding: "32px 24px",
            textAlign: "center",
            color: "#8a9ab5",
          }}
        >
          <p style={{ fontSize: "48px" }}>🖨️</p>
          <p style={{ fontSize: "18px", fontWeight: 600 }}>Coming Soon</p>
          <p>The Marriage Reprint module is under development.</p>
        </div>
        <Footer />
      </main>
    </div>
  );
};

export default WeddingReprint;
